// extracted by mini-css-extract-plugin
export default {"transparent-submit-button":"SubmitButton_transparent-submit-button__jkuZk"};